// GET 'transfer-reservations/cancel' te trae todas las reservas que han sido canceladas desde la aplicación de clientes.

import { httpClient } from 'shared/services/http/httpClient';

export const getTravelsCanceled = async () => {
  const res = await httpClient.get(`transfer-reservations/cancel`);
  return res;
};

// PUT 'transfer-reservations/{id}/cancel-check' este endpoint es para setear como vista una reserva

export const cancelCheck = async (id: number) => {
  const res = await httpClient.put(`transfer-reservations/${id}/cancel-check`);
  return res;
};
